import { render, staticRenderFns } from "./editBanner.vue?vue&type=template&id=58ebfec7&scoped=true&"
import script from "./editBanner.vue?vue&type=script&lang=js&"
export * from "./editBanner.vue?vue&type=script&lang=js&"
import style0 from "./editBanner.vue?vue&type=style&index=0&id=58ebfec7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ebfec7",
  null
  
)

export default component.exports